import { render } from "./signUp.vue?vue&type=template&id=06cc426a"
import script from "./signUpComponent.js?vue&type=script&lang=js"
export * from "./signUpComponent.js?vue&type=script&lang=js"

import "./signUp.vue?vue&type=style&index=0&id=06cc426a&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__